import './globals.js';

// --- Online/Offline detection ---
window.addEventListener('online', () => {
	$('body').classList.remove('offline');
});

window.addEventListener('offline', () => {
	$('body').classList.add('offline');
});

// --- Dynamic script injection (component client.js files) ---

import '/home/node/app/crates/game/client.js';


// --- PWA setup ---
let _swFirstInstall = false;
if (ssr.pwa && 'serviceWorker' in navigator) {
	_swFirstInstall = !navigator.serviceWorker.controller;
	await navigator.serviceWorker.register('/sw.js', { scope: '/' })
		.then(reg => l('SW registered', reg.scope))
		.catch(err => console.error('SW registration failed', err));
}

// --- Render adapter setup ---
// The server replaces this build-time constant for every client bundle. Keeping
// the decision at build time lets esbuild remove the unused adapter and makes a
// Canvas installation genuinely independent of the optional Vidoriel package.
let adapter;
if (__HYBRILIOR_RENDER_MODE__ === 'canvas') {
	// Canvas/game mode: project must provide a renderer via ssr.renderer
	// or register one in a client.js script above
	const { CanvasAdapter } = await import('./adapters/canvas-adapter.js');
	adapter = new CanvasAdapter(globalThis.$renderer || ssr.renderer);
} else {
	// Default: Vidoriel DOM patching
	const { VidorielAdapter, vidorielGlobalControllerHandler } = await import('./adapters/vidoriel-adapter.js');
	adapter = new VidorielAdapter();
	// Register Vidoriel's global controller handler (used by @import system)
	globalThis.vidorielGlobalControllerHandler = vidorielGlobalControllerHandler;
}

navigation.setRenderAdapter(adapter);

// Delegate view resolution to the adapter
const { Component } = await import('./component.js');
Component.resolveViewPath = (component, viewsDir) => adapter.resolveViewPath(component, viewsDir);

// --- Bootstrap ---
// Initialize the render adapter with SSR data
const content = await adapter.init(ssr);

// Use the leaf controller from the adapter's chain — NOT a separate instance.
// The adapter's buildChain already imports and instantiates all controllers;
// creating another one here would produce a disconnected duplicate.
const controller = content?.data || ssr.data || {};

navigation.up(location.pathname.slice(1), controller, true);

// --- First SW install: reload so SW controls all requests ---
if (_swFirstInstall) {
	if (navigator.serviceWorker.controller) {
		location.reload();
	} else {
		navigator.serviceWorker.addEventListener('controllerchange', () => {
			location.reload();
		});
	}
}

// --- Global reload function ---
globalThis.reloadApp = async function(path) {
	if (adapter.reload) {
		await adapter.reload();
	}
	if (path) {
		navigation.loadPage(path);
	} else {
		navigation.reloadPage();
	}
};
